// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var AutoAdvance$ReactHooksTemplate = require("./autoAdvance.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");

function AutoAdvances(props) {
  var __enforceable = props.enforceable;
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var enforceable = __enforceable !== undefined ? __enforceable : true;
  var value = AutoAdvance$ReactHooksTemplate.value(setting);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("span", {
                                      children: "⚡",
                                      className: "text-lg"
                                    }),
                                JsxRuntime.jsx("h2", {
                                      children: "Auto Advance",
                                      className: "text-lg font-bold text-gray-900"
                                    }),
                                enforced ? JsxRuntime.jsx("span", {
                                        children: "🔒 Enforced",
                                        className: "text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded-full"
                                      }) : null
                              ],
                              className: "flex items-center space-x-2"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Automatically advance users through survey questions without manual navigation",
                              className: "text-sm text-gray-600 mt-1"
                            })
                      ],
                      className: "bg-gradient-to-r from-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                              checked: value,
                                                              disabled: enforced,
                                                              handleChange: (function (param) {
                                                                  if (enforced) {
                                                                    return ;
                                                                  } else {
                                                                    return Curry._2(onChange, {
                                                                                TAG: "AutoAdvance",
                                                                                _0: AutoAdvance$ReactHooksTemplate.setValue(setting, !value)
                                                                              }, enforce);
                                                                  }
                                                                }),
                                                              labelClassName: "flex items-center"
                                                            }),
                                                        JsxRuntime.jsx("span", {
                                                              children: "Enable Auto Advance",
                                                              className: "text-sm font-medium text-gray-700"
                                                            })
                                                      ],
                                                      className: "flex items-center space-x-2"
                                                    }),
                                                value ? JsxRuntime.jsx("span", {
                                                        children: "Active",
                                                        className: "inline-flex items-center px-2 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full"
                                                      }) : JsxRuntime.jsx("span", {
                                                        children: "Disabled",
                                                        className: "inline-flex items-center px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full"
                                                      })
                                              ],
                                              className: "flex items-center space-x-3"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Users will automatically move to the next question after answering",
                                              className: "text-xs text-gray-500 mt-2"
                                            })
                                      ],
                                      className: "flex-1"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: enforceable ? JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                      checked: enforce,
                                                      disabled: enforced,
                                                      label: "Enforce Policy",
                                                      handleChange: (function (param) {
                                                          if (!enforced) {
                                                            return Curry._2(onChange, {
                                                                        TAG: "AutoAdvance",
                                                                        _0: setting
                                                                      }, !enforce);
                                                          }
                                                          
                                                        }),
                                                      checkboxClassName: "custom_checkbox"
                                                    }),
                                                enforce ? JsxRuntime.jsx("span", {
                                                        children: "🔒",
                                                        className: "text-xs font-medium text-blue-700"
                                                      }) : null
                                              ],
                                              className: "flex items-center space-x-2 px-4 py-2 rounded-lg " + (
                                                enforce ? "bg-blue-100 border border-blue-200" : "bg-white border border-gray-200"
                                              )
                                            }) : null,
                                      className: "ml-6"
                                    })
                              ],
                              className: "flex items-center justify-between"
                            }),
                        enforced ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "⚠️",
                                              className: "text-sm"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("p", {
                                                    children: "This setting is enforced and cannot be modified",
                                                    className: "text-xs font-medium text-yellow-900"
                                                  })
                                            })
                                      ],
                                      className: "flex items-start space-x-2"
                                    }),
                                className: "mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg"
                              }) : null
                      ],
                      className: "p-6"
                    })
              ]
            });
}

var make = AutoAdvances;

exports.make = make;
/* react/jsx-runtime Not a pure module */
